<p-dialog
  [visible]="visible()"
  (visibleChange)="onDialogVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="!isSubmitting()"
  [dismissableMask]="false"
  [style]="{ width: '38rem' }"
  [header]="dialogTitle() | translate"
  styleClass="custom-domains-wizard">
  <div class="wizard-body">
    @if (showStepper()) {
      <ol class="stepper" aria-label="Steps">
        <li class="step" [class.active]="stepperIndex() >= 1" [class.done]="stepperIndex() > 1">
          <span class="step-num">
            @if (stepperIndex() > 1) {
              <i class="pi pi-check"></i>
            } @else {
              1
            }
          </span>
          <span class="step-label">{{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.STEP_ENTER' | translate }}</span>
        </li>
        <li class="step-sep" aria-hidden="true"></li>
        <li class="step" [class.active]="stepperIndex() >= 2" [class.done]="stepperIndex() > 2">
          <span class="step-num">
            @if (stepperIndex() > 2) {
              <i class="pi pi-check"></i>
            } @else {
              2
            }
          </span>
          <span class="step-label">{{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.STEP_VERIFY' | translate }}</span>
        </li>
      </ol>
    }

    <tf-settings-inline-message
      [message]="generalError()"
      messageId="custom-domain-dialog-error"
      (dismissed)="clearGeneralError()" />

    @switch (step()) {
      @case ('enter') {
        <form class="field-block" (submit)="$event.preventDefault()">
          <label for="custom-domain-input" class="field-label-strong">
            {{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.DOMAIN_LABEL' | translate }}
          </label>
          <input
            pInputText
            id="custom-domain-input"
            type="text"
            class="w-full"
            [ngModel]="formModel().domain"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onDomainInputChange($event)"
            [placeholder]="'SETTINGS_CUSTOM_DOMAINS.WIZARD.DOMAIN_PLACEHOLDER' | translate"
            autocomplete="off"
            autocapitalize="off"
            spellcheck="false"
            [class.ng-invalid]="!!serverErrors.get('domain') || !!apexError()"
            [attr.aria-invalid]="serverErrors.get('domain') || apexError() ? true : null"
            [attr.aria-describedby]="serverErrors.get('domain') || apexError() ? 'domain-error' : 'domain-helper'" />
          @if (apexError() ?? serverErrors.get('domain'); as msg) {
            <small id="domain-error" class="p-error" role="alert">{{ msg }}</small>
          } @else {
            <small id="domain-helper" class="field-helper">
              {{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.DOMAIN_HELPER' | translate }}
            </small>
          }
        </form>
        <div class="info-banner" role="note">
          <i class="pi pi-info-circle"></i>
          <span>{{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.ENTER_INFO' | translate }}</span>
        </div>
      }
      @case ('verify') {
        <div class="section-text">
          <h3 class="section-title">{{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_RECORD_TITLE' | translate }}</h3>
          <p class="section-body">{{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.VERIFY_BODY' | translate }}</p>
        </div>
        <ng-container *ngTemplateOutlet="dnsCards"></ng-container>
        <div class="info-banner" role="note">
          <i class="pi pi-info-circle"></i>
          <span>{{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.VERIFY_INFO' | translate }}</span>
        </div>
      }
      @case ('verify-fail') {
        <div class="section-text">
          <h3 class="section-title">{{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.FAIL_TITLE' | translate }}</h3>
          <p class="section-body">{{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.FAIL_BODY' | translate }}</p>
        </div>
        <ng-container *ngTemplateOutlet="dnsCards"></ng-container>
      }
      @case ('verify-success') {
        <div class="success-block">
          <div class="success-icon" aria-hidden="true">
            <i class="pi pi-check"></i>
          </div>
          <h3 class="success-title">
            {{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.SUCCESS_TITLE' | translate }}
          </h3>
          <p class="success-body">
            {{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.SUCCESS_BODY' | translate }}
          </p>
          @if (currentDomain(); as domain) {
            <span class="domain-chip">
              <span class="domain-chip-dot" aria-hidden="true"></span>
              <span class="domain-chip-name">{{ domain.domain }}</span>
            </span>
          }
        </div>
      }
      @case ('registry-blocked') {
        <div class="error-block" role="alert">
          <div class="error-icon" aria-hidden="true">
            <i class="pi pi-lock"></i>
          </div>
          <div class="error-content">
            <p class="error-head">
              {{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.REGISTRY_BLOCKED_TITLE' | translate }}
            </p>
            <p class="error-body">{{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.REGISTRY_BLOCKED_BODY' | translate }}</p>
          </div>
        </div>
      }
    }
  </div>

  <ng-template pTemplate="footer">
    @switch (step()) {
      @case ('enter') {
        <p-button
          [label]="'SETTINGS_CUSTOM_DOMAINS.WIZARD.CANCEL' | translate"
          severity="secondary"
          [text]="true"
          [disabled]="isSubmitting()"
          (onClick)="onCancel()" />
        <p-button
          [label]="'SETTINGS_CUSTOM_DOMAINS.WIZARD.ADD_DOMAIN' | translate"
          [loading]="isSubmitting()"
          [disabled]="isSubmitting()"
          (onClick)="onAddDomain()" />
      }
      @case ('verify') {
        <p-button
          [label]="'SETTINGS_CUSTOM_DOMAINS.WIZARD.BACK' | translate"
          severity="secondary"
          [text]="true"
          [disabled]="isSubmitting()"
          (onClick)="onCancel()" />
        <p-button
          icon="pi pi-check"
          [label]="'SETTINGS_CUSTOM_DOMAINS.WIZARD.VERIFY_NOW' | translate"
          [loading]="isSubmitting()"
          [disabled]="isSubmitting()"
          (onClick)="onVerifyNow()" />
      }
      @case ('verify-fail') {
        <p-button
          [label]="'SETTINGS_CUSTOM_DOMAINS.WIZARD.BACK' | translate"
          severity="secondary"
          [text]="true"
          [disabled]="isSubmitting()"
          (onClick)="onCancel()" />
        <p-button
          icon="pi pi-refresh"
          [label]="'SETTINGS_CUSTOM_DOMAINS.WIZARD.TRY_AGAIN' | translate"
          [loading]="isSubmitting()"
          [disabled]="isSubmitting()"
          (onClick)="onVerifyNow()" />
      }
      @case ('verify-success') {
        <p-button
          [label]="'SETTINGS_CUSTOM_DOMAINS.WIZARD.OPEN_IN_BRANDS' | translate"
          severity="secondary"
          [text]="true"
          icon="pi pi-arrow-right"
          iconPos="right"
          (onClick)="openBrandsSettings()" />
        <p-button
          [label]="'SETTINGS_CUSTOM_DOMAINS.WIZARD.DONE' | translate"
          (onClick)="onCancel()" />
      }
      @case ('registry-blocked') {
        <p-button
          [label]="'SETTINGS_CUSTOM_DOMAINS.WIZARD.CANCEL' | translate"
          severity="secondary"
          [text]="true"
          (onClick)="onCancel()" />
      }
    }
  </ng-template>

  <ng-template #dnsCards>
    @if (currentDomain(); as domain) {
      <div class="dns-card" [class.dns-card--failed]="!!txtFailure()" aria-label="DNS TXT record">
        @if (txtFailure(); as failure) {
          <p class="dns-card-status dns-card-status--failed" role="alert">
            <i class="pi pi-times-circle" aria-hidden="true"></i>
            {{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.TXT_FAIL_MESSAGE' | translate }}
          </p>
        }
        <div class="dns-row">
          <span class="dns-row-label">{{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_TYPE' | translate }}</span>
          <span class="dns-row-value">TXT</span>
          <span class="dns-row-action" aria-hidden="true"></span>
        </div>
        <div class="dns-row">
          <span class="dns-row-label">{{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_NAME' | translate }}</span>
          <span class="dns-row-value">{{ domain.txtRecord.recordName }}</span>
          <button
            type="button"
            class="copy-btn"
            [attr.aria-label]="'SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_COPY' | translate"
            (click)="copyToClipboard(domain.txtRecord.recordName, 'txt-name')">
            <i [class]="copiedField() === 'txt-name' ? 'pi pi-check' : 'pi pi-copy'"></i>
            {{ copiedField() === 'txt-name'
              ? ('SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_COPIED' | translate)
              : ('SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_COPY' | translate) }}
          </button>
        </div>
        <div class="dns-row">
          <span class="dns-row-label">{{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_VALUE' | translate }}</span>
          <span class="dns-row-value">{{ domain.txtRecord.recordValue }}</span>
          <button
            type="button"
            class="copy-btn"
            [attr.aria-label]="'SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_COPY' | translate"
            (click)="copyToClipboard(domain.txtRecord.recordValue, 'txt-value')">
            <i [class]="copiedField() === 'txt-value' ? 'pi pi-check' : 'pi pi-copy'"></i>
            {{ copiedField() === 'txt-value'
              ? ('SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_COPIED' | translate)
              : ('SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_COPY' | translate) }}
          </button>
        </div>
      </div>
      <div class="dns-card" [class.dns-card--failed]="!!cnameFailure()" aria-label="DNS CNAME record">
        @if (cnameFailure(); as failure) {
          <p class="dns-card-status dns-card-status--failed" role="alert">
            <i class="pi pi-times-circle" aria-hidden="true"></i>
            @if (cnameActualTargets(failure); as actuals) {
              {{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.CNAME_FAIL_WITH_ACTUALS' | translate: { actuals: actuals } }}
            } @else {
              {{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.CNAME_FAIL_MESSAGE' | translate }}
            }
          </p>
        }
        <div class="dns-row">
          <span class="dns-row-label">{{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_TYPE' | translate }}</span>
          <span class="dns-row-value">CNAME</span>
          <span class="dns-row-action" aria-hidden="true"></span>
        </div>
        <div class="dns-row">
          <span class="dns-row-label">{{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_NAME' | translate }}</span>
          <span class="dns-row-value">{{ domain.cnameRecord.recordName }}</span>
          <button
            type="button"
            class="copy-btn"
            [attr.aria-label]="'SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_COPY' | translate"
            (click)="copyToClipboard(domain.cnameRecord.recordName, 'cname-name')">
            <i [class]="copiedField() === 'cname-name' ? 'pi pi-check' : 'pi pi-copy'"></i>
            {{ copiedField() === 'cname-name'
              ? ('SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_COPIED' | translate)
              : ('SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_COPY' | translate) }}
          </button>
        </div>
        <div class="dns-row">
          <span class="dns-row-label">{{ 'SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_TARGET' | translate }}</span>
          <span class="dns-row-value">{{ domain.cnameRecord.recordTarget }}</span>
          <button
            type="button"
            class="copy-btn"
            [attr.aria-label]="'SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_COPY' | translate"
            (click)="copyToClipboard(domain.cnameRecord.recordTarget, 'cname-target')">
            <i [class]="copiedField() === 'cname-target' ? 'pi pi-check' : 'pi pi-copy'"></i>
            {{ copiedField() === 'cname-target'
              ? ('SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_COPIED' | translate)
              : ('SETTINGS_CUSTOM_DOMAINS.WIZARD.DNS_COPY' | translate) }}
          </button>
        </div>
      </div>
    }
  </ng-template>
</p-dialog>
